import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import './App.css';

import { UserProvider } from './contexts/UserContext';
import ProtectedRoute from './components/ProtectedRoute';
import Admin from "./components/Admin/admin";
import Login from './components/Registro/Login';
import Productos from './components/Productos/productos';
import DetalleProducto from "./components/Productos/DetalleProducto";
import Contacto from './components/Contacto/Contacto';
import Nosotros from "./components/Nosotros/Nosotros";
import Inicio from './components/Inicio/Inicio'
import WhatsAppButton from './components/whatsAppButton/WhatsAppButton'
import ChatBot from './components/chatBot/ChatBot';
import Layout from './components/Layout';
import NotFound from './components/NotFound/NotFound';
import EnviosYDevoluciones from "./components/Legales/EnviosYDevoluciones";
import CondicionesGeneralesVenta from "./components/Legales/CondicionesGeneralesVenta";
import PoliticaPrivacidadYCookies from "./components/Legales/PoliticaPrivacidadYCookies";

ReactGA.initialize("G-JPM5P0ZBVD");


function AnalyticsHandler() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null;
}


function App() {
  const [terminoBusqueda, setTerminoBusqueda] = useState('');
  const [productos, setProductos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/data/products.json');
        if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

        const data = await response.json();
        setProductos(data);
      } catch (error) {
        console.error('❌ Error al cargar los datos:', error);
      }
    };
    fetchData();
  }, []);


  const productosFiltrados = terminoBusqueda
    ? productos.filter((producto) =>
      producto.nombre.toLowerCase().includes(terminoBusqueda.toLowerCase())
    )
    : productos;

  return (
    <UserProvider>


      <BrowserRouter>
        <AnalyticsHandler />
        <Layout>
          <Routes>
            {/* Rutas públicas */}
            <Route path="/" element={<Inicio />} />
            <Route path="/productos" element={<Productos />} />
            <Route path="/productos/:slug" element={<DetalleProducto />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/nosotros" element={<Nosotros />} />

            <Route path="*" element={<NotFound />} />
            <Route path="/envios-y-devoluciones" element={<EnviosYDevoluciones />} />
            <Route path="/condiciones-generales" element={<CondicionesGeneralesVenta />} />
            <Route path="/politica-de-privacidad" element={<PoliticaPrivacidadYCookies />} />


            {/* Rutas protegidas */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="Admin">
                  <Admin />
                </ProtectedRoute>
              }
            />

            {/* Auth */}
            <Route path="/login-admin" element={<Login />} />
          </Routes>
        </Layout>

        <ChatBot />
        <WhatsAppButton />
      </BrowserRouter>

    </UserProvider>
  );
}

export default App;
